import { useState, useLayoutEffect } from "react";
import axios from 'axios';
import Config from "../../Config";
import { RootState } from "../../store";
import { useSelector } from "react-redux";

import { useTheme, styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
//import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import MuiDrawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { NavLink } from "react-router-dom";
import { List } from "@mui/material";
import { useGetMyUserQuery } from "../../gateways/cms/userApi";
import { useGetTaskCountQuery } from "../../gateways/cms/taskApi";
import { useGetDefaultUrlQuery } from "../../gateways/cms/schemaApi";

import Color from "../../styles/colors.js";
import VarConst from "../../styles/variables.js";

const drawerWidth: number = 240;
const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
})(
    ({theme, open}) => ({
        "& .MuiDrawer-paper": {
            position: "relative",
            whiteSpace: "nowrap",
            width: drawerWidth,
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: "border-box",
            ...(!open && {
                overflowX: "hidden",
                transition: theme.transitions.create("width", {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up("sm")]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
    `

.MuiDrawer-paper {
    //background-color: var.$RGB-primary;
    background-color: ${Color.backColor};
    width: 260px;

    .MuiList-root{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        height: 100%;
        // padding-top: $header-H;
        padding-top: ${VarConst.headerH};

        .MuiBox-root {
            width: 100%;
            padding-top: 40px;

            &:nth-of-type(3) {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                padding-bottom: 40px;
            }

            &:nth-of-type(1) {
                a:nth-of-type(1) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_monitor.svg`)} ); }     // @include icon.Svg-monitor(#fff);
                a:nth-of-type(2) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_task.svg`)} ); }     // @include icon.Svg-task(#fff);
                a:nth-of-type(3) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_movie.svg`)} ); }     // @include icon.Svg-movie(#fff);
                a:nth-of-type(4) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_list.svg`)} ); }     // @include icon.Svg-list(#fff);
                a:nth-of-type(5) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_calendar.svg`)} ); }     // @include icon.Svg-calendar(#fff);
            }
            &:nth-of-type(2) {
                a:nth-of-type(1) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_setting.svg`)} ); }     // @include icon.Svg-setting(#fff);
                a:nth-of-type(2) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_shop.svg`)} ); }     // @include icon.Svg-shop(#fff);
                a:nth-of-type(3) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_member.svg`)} ); }     // @include icon.Svg-member(#fff);
                a:nth-of-type(4) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_monitor.svg`)} ); }     // @include icon.Svg-monitor(#fff);
                a:nth-of-type(5) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_paper_DL.svg`)} ); }     // @include icon.Svg-paper_DL(#fff);
                a:nth-of-type(6) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_paper_DL.svg`)} ); }     // @include icon.Svg-paper_DL(#fff);
            }
            &:nth-of-type(3) {
                a:nth-of-type(1) .MuiListItemIcon-root { background-image: url( ${require(`../../assets/globalmenu/icon_maintenance.svg`)} ); }     // @include icon.Svg-maintenance(#fff);
            }
        }
    }

    a {
        color: #fff;
        padding: 16px 16px 16px 24px;
        font-size: 14px;

        &.active,
        &:hover {
            // background-color: var.$RGB-nav_hover;
            background-color: ${Color.hoverColor};
        }

        // 元々のアイコン
        .MuiListItemIcon-root {
            min-width: 24px;
            margin-right: 8px;
        }
        svg {
            color: transparent;
        }
    }
}
`
);

export interface DrawerMenuProps {
    isDrawerOpen: boolean;
    toggleDrawer: () => void;
}

export default function DrawerMenu({ isDrawerOpen, toggleDrawer }: DrawerMenuProps) {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const GetTaskCount = useGetTaskCountQuery();
    const GetDefaultUrl = useGetDefaultUrlQuery();
    //const [defaultUrl, setDefaultUrl] = useState(GetDefaultUrl.currentData || "/articles?status=50&status=1");
    const [defaultUrl, setDefaultUrl] = useState(GetDefaultUrl.currentData || "/articles?status=40&status=50&status=1");
    const [taskCount, setTaskCount] = useState(String(GetTaskCount.data || "0"));
    const token = useSelector((state: RootState) => state.auth.token);
    //console.log(GetDefaultUrl.data);
    //console.log(defaultUrl);
    useLayoutEffect(() => {
        if (typeof GetTaskCount.currentData === "string") {
            setTaskCount(GetTaskCount.currentData);
        }
    },[GetTaskCount]);

    useLayoutEffect(() => {
        if (typeof GetDefaultUrl.currentData === "string") {
            setDefaultUrl(GetDefaultUrl.currentData);
        }
    },[GetDefaultUrl]);

    // ユーザー情報取得
    const user = useGetMyUserQuery();
    if (!user.data) {
        return <div></div>;
    };

    /*** 未対応タスク数を取得する関数の定義 ***/
    // ヘッダー
    const instance = axios.create({
        baseURL: Config.baseEndpoint,
        headers: {
            Accept: "application/json, application/octet-stream",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
    // 未対応タスク数取得
    const getTaskCount = async() => {
        // ここでAPIを叩いてデータを取得
        const response = await instance.get('/task_count');
        if (typeof response.data === "string"){
            setTaskCount(response.data);
        }else{
            console.log('タスク数の型がunkown:', response.data);
        }
    }

    // 10分ごとに未対応タスク数取得関数を実行
    setInterval(getTaskCount, 10 * 60 * 1000);

    // 表示するメニュー（権限）のリスト
    // const menu = user.data.authority;
    return (
        <Drawer
            className="globalmenu"
            // ★ 1. PCでは persistent（横に並ぶ）、スマホでは temporary（被さる）
            variant="permanent"
            open={isDrawerOpen}
            onClose={toggleDrawer}
            anchor="left"
            // ニュッとする動きを消す

            sx={{
                // ★ 2. スマホの時だけ、強制的に「非表示」にする（これでパッと消える）
                display: { xs: isDrawerOpen ? "block" : "none", md: "block" },
                
                // ★ 3. PC版で開閉した時にメインを押し出す幅の指定
                width: isDrawerOpen ? drawerWidth : 0,
                flexShrink: 0,
                transition: "none",

                "& .MuiDrawer-paper": {
                    width: drawerWidth,
                    boxSizing: "border-box",
                    backgroundColor: Color.backColor,
                    // ★ 4. PCでは横並び(relative)、スマホでは上に被さる(fixed)
                    position: { xs: "fixed", md: isDrawerOpen ? "relative" : "fixed" },
                    transition: "none !important",
                    // スマホで開いた時に一番上にくるように
                    zIndex: 1200,
                },
            }}

        >
            <List className="globalmenu-main">
                <Box>
                    {/* ★変更点：checkSpecialty（専門店街スタッフ）ではない場合のみ通常メニューを表示 */}
                    {!user.data.checkSpecialty && (
                        <>
                            <ListItem component={NavLink} to="/logs/terminal-status">
                                <ListItemIcon>
                                    <DashboardIcon />
                                </ListItemIcon>
                                <ListItemText primary="端末状態" />
                            </ListItem>

                            <ListItem component={NavLink} to="/tasks">
                                <ListItemIcon>
                                    <DashboardIcon />
                                </ListItemIcon>
                                <ListItemText primary="タスク管理" />
                                {(taskCount && taskCount > "0") && (
                                    <Chip
                                        label={taskCount}
                                        color="error"
                                        size="small"
                                    />
                                )}
                            </ListItem>

                            <ListItem component={NavLink} to={String(defaultUrl)}>
                                <ListItemIcon>
                                    <DashboardIcon />
                                </ListItemIcon>
                                <ListItemText primary="コンテンツ管理" />
                            </ListItem>

                            <ListItem component={NavLink} to="/delivery-groups">
                                <ListItemIcon>
                                    <DashboardIcon />
                                </ListItemIcon>
                                <ListItemText primary="掲載順管理" />
                            </ListItem>

                            {!user.data?.checkAgent ? (
                                <ListItem component={NavLink} to="/delivery-rules">
                                    <ListItemIcon>
                                        <DashboardIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="稼働スケジュール管理" />
                                </ListItem>
                            ):(<ListItem></ListItem>)}
                        </>
                    )}

                    {/* タッチ管理は未実装のため一時的に非表示
                    <ListItem component={NavLink} to="/touch-management">
                        <ListItemIcon>
                            <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText primary="タッチ管理" />
                    </ListItem>
                    */}
                </Box>

                {/* Menu Grounp 2*/}
                {user.data?.checkAdmin ? (
                    <Box>
                        <ListItem component={NavLink} to="/schema-definitions">
                            <ListItemIcon>
                                <DashboardIcon />
                            </ListItemIcon>
                            <ListItemText primary="コンテンツスキーマ管理" />
                        </ListItem>

                        <ListItem component={NavLink} to="/organizations">
                            <ListItemIcon>
                                <DashboardIcon />
                            </ListItemIcon>
                            <ListItemText primary="テナント管理" />
                        </ListItem>

                        <ListItem component={NavLink} to="/users">
                            <ListItemIcon>
                                <DashboardIcon />
                            </ListItemIcon>
                            <ListItemText primary="ユーザー管理" />
                        </ListItem>

                        <ListItem component={NavLink} to="/logs/terminal-error">
                            <ListItemIcon>
                                <DashboardIcon />
                            </ListItemIcon>
                            <ListItemText primary="異常端末管理" />
                        </ListItem>

                        {/*
                        <ListItem component={NavLink} to="/logs/billing-data">
                            <ListItemIcon>
                                <DashboardIcon />
                            </ListItemIcon>
                            <ListItemText primary="請求データダウンロード" />
                        </ListItem>
                        */}
                        <ListItem component={NavLink} to="/logs/billing-csv">
                            <ListItemIcon>
                                <DashboardIcon />
                            </ListItemIcon>
                            <ListItemText primary="請求元CSVダウンロード" />
                        </ListItem>
                    </Box>
                ):(<Box></Box>)}

                {/* Menu Grounp Bottom */}
                {!user.data.checkSpecialty && (
                    <Box>
                        <ListItem component={NavLink} to="/">
                            <ListItemIcon>
                                {" "}
                                <DashboardIcon />{" "}
                            </ListItemIcon>
                            <ListItemText primary="設定" />
                        </ListItem>
                    </Box>
                )}
            </List>
        </Drawer>
    );
}
